<script setup>
import { ref } from 'vue';
import { debounce } from 'lodash';
import axios from '@/libs/cifra/axios';
import SelectCifra from '@/components/inputs/SelectCifra.vue';

/*
Para los datos usamos por defecto formato select2:
{"results":[{"id":76211,"text":"Matemáticas"},{"id":55832,"text":"lengua"}]}
*/
const props = defineProps({
  url: { type: String, required: true },
  params: { type: Function, default: undefined },
  marcador: { type: String, default: undefined },
  buscable: { type: Boolean, default: undefined },
  deshabilitado: { type: Boolean, default: false },
});

const modelInterno = defineModel({
  type: [Object, String, Number],
  default: null,
});

const options = ref([]);
const loading = ref(false);

const ajaxSearch = debounce((texto) => {
  loading.value = true;

  let params = { q: texto };
  if (props.params) {
    params = props.params(texto);
  }

  axios.get(props.url, { params }).then((result) => {
    options.value = result.data.results;
    loading.value = false;
  }).catch(() => {
    loading.value = false;
  });
}, 350);

const onSearch = (texto) => {
  if (texto.length) {
    ajaxSearch(texto);
  }
};

const load = () => {
  ajaxSearch('');
};

defineExpose({
  load,
});
</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :mostrar-limpiar="true"
    :opciones="options"
    :cargando="loading"
    :busqueda-interna="false"
    campo-etiqueta="text"
    campo-id="id"
    :marcador="marcador"
    :buscable="buscable"
    :deshabilitado="deshabilitado"
    @cambio-busqueda="onSearch"
  >
    <template #opcion="{ opcion }">
      <slot name="opcion" :opcion="opcion">
        <span>{{ opcion.text }}</span>
      </slot>
    </template>
  </SelectCifra>
</template>
